import { InfoIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

interface BaseTooltipProps {
      children: React.ReactNode;
      trigger?: React.ReactNode;
      triggerClassName?: string;
      contentClassName?: string;
}

export type BaseTooltipTriggerProps = Pick<BaseTooltipProps, "trigger" | "triggerClassName">;

export const BaseTooltip = ({
      children,
      trigger,
      triggerClassName,
      contentClassName,
}: BaseTooltipProps) => {
      return (
            <Tooltip>
                  <TooltipTrigger asChild>
                        {trigger ? (
                              <span className={cn("inline-flex items-center pointer-events-auto", triggerClassName)}>
                                    {trigger}
                              </span>
                        ) : (
                              <button
                                    type="button"
                                    className={cn("inline-flex items-center pointer-events-auto", triggerClassName)}
                              >
                                    <InfoIcon className="size-4" />
                              </button>
                        )}
                  </TooltipTrigger>
                  <TooltipContent className={contentClassName}>{children}</TooltipContent>
            </Tooltip>
      );
};
